import { useState, useEffect } from "react";
import { usePartner } from "../PartnerContext";
import { MessageCircle, X } from "lucide-react";

export const WhatsAppFloat = () => {
  const { whatsappLink } = usePartner();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-3">
      {open && (
        <div className="relative mb-1 hidden max-w-[210px] rounded-2xl border border-white/10 bg-[#0B111E] p-3 pr-7 shadow-2xl sm:block">
          <button
            onClick={() => setOpen(false)}
            className="absolute right-1.5 top-1.5 text-gray-500 hover:text-white"
            data-testid="float-close"
          >
            <X className="h-3.5 w-3.5" />
          </button>
          <p className="text-xs font-semibold text-white">Bock auf den Job? 🚗</p>
          <p className="mt-0.5 text-[11px] text-gray-400">Schreib uns – wir antworten sofort!</p>
        </div>
      )}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        className="pulse-ring flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-[#1E90FF] to-[#60A5FA] text-[#05070D] shadow-lg transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle className="h-7 w-7" strokeWidth={2.5} />
      </a>
    </div>
  );
};
